import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconAdd, IconSortHandle } from '../../../../assets/icons';
import { EmptyStateBox, Header, NavHeader, Page } from '../../../../components';
import { UserGroup, UserPermissionType } from '../../../../data-access/gql-types/graphql';
import { useUserPermissions } from '../../../../hooks/user/use-user-permissions';
import { ROUTES } from '../../../../routes/routes';
import { GroupItem } from '../../components/group';
import { useGroups } from '../../hooks/groups/use-groups';

const GroupList: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('groups');
  const [groups, setGroups] = useState<UserGroup[]>();
  const { groups: groupsData } = useGroups();
  const { permissions } = useUserPermissions();

  useEffect(() => setGroups(groupsData), [groupsData]);

  const handleSortButton = () => navigate(ROUTES.GroupSort());

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader>
            {permissions[UserPermissionType.GroupCreate] ? (
              <button onClick={() => navigate(ROUTES.GroupCreate())}>
                <IconAdd />
              </button>
            ) : null}
            <button className="p-l-0 p-r-0" onClick={handleSortButton}>
              <IconSortHandle />
            </button>
          </NavHeader>
          <Header title={t('allGroups')} />
        </>
      }
    >
      {groups?.length ? (
        <div className="grid-list-16">
          {groups.map((group: UserGroup) => (
            <GroupItem key={group.id} id={group.id} groups={groups} />
          ))}
        </div>
      ) : (
        <EmptyStateBox
          header={t('groups')}
          content={t('descriptionEmptyList')}
          {...(permissions[UserPermissionType.GroupCreate]
            ? { btnText: t('create'), linkTo: ROUTES.GroupCreate() }
            : {})}
        />
      )}
    </Page>
  );
};

export default GroupList;
